

const postalCodeNormalizerGB = (value) => {
    if (!value) return value;
    const alphaNumSpaces = new RegExp(/[^0-9a-zA-Z ]*/g);
    return value.replace(alphaNumSpaces, '').toUpperCase().slice(0, 8);
};

export default postalCodeNormalizerGB;
